export var CookieBotConsentType = /*#__PURE__*/function (CookieBotConsentType) {
  CookieBotConsentType["marketing"] = "marketing";
  CookieBotConsentType["statistics"] = "statistics";
  return CookieBotConsentType;
}(CookieBotConsentType || {});
/**
 * The names of cookies different pixel providers store their click ids in.
 * We use these in payloads to CAPIs and/or pixel events.
 */
export var PixelClickIdCookie = /*#__PURE__*/function (PixelClickIdCookie) {
  PixelClickIdCookie["_fbc"] = "_fbc";
  PixelClickIdCookie["_fbp"] = "_fbp";
  /**
   * Stored by us if we only receive fbclid and don't have an fbc cookie.
   */
  PixelClickIdCookie["fbclid"] = "fbclid";
  PixelClickIdCookie["irclickid"] = "irclickid";
  PixelClickIdCookie["_scid"] = "_scid";
  /**
   * Stored by us if we only receive the ScCid parameter and don't have an _scid cookie.
   */
  PixelClickIdCookie["ScCid"] = "ScCid";
  return PixelClickIdCookie;
}(PixelClickIdCookie || {});